// extracted by mini-css-extract-plugin
module.exports = {"infoText":"style__infoText__Sek8S"};